export default __webpack_public_path__ + "images/marker-outline.png?3983e7df41de2eb897571b2af04286ee";